import { useTranslation } from 'react-i18next';
import { InlineAnchor, Typography } from '@figure/frontlib-gui';
import ReviewAppBase from '../components/ReviewAppBase';

const IncorrectPinContainer = () => {
  const [t] = useTranslation();

  return (
    <ReviewAppBase>
      <Typography.Body>
        Your credit is locked and the single use pin you provided was incorrect. Our Customer Support Team will be happy to help
        resolve this issue. Please contact us at{' '}
        <InlineAnchor href={`tel:+${t('phone.unformatted')}`}>{t('phone.formatted')}</InlineAnchor> Monday - Sunday between 6am - 6pm
        PT. If you have forgotten or need to reset your pin, visit{' '}
        <InlineAnchor
          href="https://www.experian.com/blogs/ask-experian/replacing-a-lost-security-freeze-pin-number/#:~:text=If%20you%20lose%20your%20PIN,new%20PIN%20can%20be%20issued."
          target="_blank"
          rel="noreferrer noopener"
        >
          Experian's website
        </InlineAnchor>{' '}
        for instructions prior to contacting us. We hope to be able to serve you!
      </Typography.Body>
    </ReviewAppBase>
  );
};

export default IncorrectPinContainer;
